export default __webpack_public_path__ + "static/media/pic9.1a0c1aa4.jpg";